<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<br/><p style="text-indent:00em;">After graduating from the University of Oklahoma (oh – so long ago), David bolted to Los Angeles to find something – anything – different from the red-dirt predictability of his native land. In California, he eventually found his niche – writing advertising, TV comedies, and dozens upon dozens of live corporate stage productions.</p>
<br/><p style="text-indent:00em;">Decades later, David returned to his Oklahoma roots to be warmly greeted by family and long-lost friends, plus the cold reality of a pandemic…which gave him more than enough time to write.</p>
<br/><p style="text-indent:00em;">Hence, came up his first novel – <em>Medicine Park</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3f0c49c8